import { render, staticRenderFns } from "./VideoRoomError.vue?vue&type=template&id=a68dcf3c&scoped=true&"
import script from "./VideoRoomError.vue?vue&type=script&lang=js&"
export * from "./VideoRoomError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68dcf3c",
  null
  
)

/* custom blocks */
import block0 from "./VideoRoomError.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VideoRoomError.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports